// Lib imports
import Vue from 'vue';
import Router from 'vue-router';

import store from '../store';
import routes from './routes';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior(to) {
    return (to.hash) ? { selector: to.hash } : undefined;
  },
});
router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters['auth/isLoggedIn'];

  if (to.name === 'PublicInfo' && isLoggedIn) {
    next({ name: 'Info', params: to.params });
  } else if (to.name === 'Info' && !isLoggedIn) {
    next({ name: 'PublicInfo', params: to.params });
  } else if (to.meta.ignoreGate) {
    next();
  } else if (to.meta.isPublicPage) {
    if (!isLoggedIn) {
      next();
    } else {
      next({ name: 'ccAllEvents' });
    }
  } else if (to.matched.some(record => record.meta.requiresAuth)) {
    if (isLoggedIn) {
      next();
    } else {
      next({ name: to.name === 'PersonalWall' ? 'PublicEvents' : 'signIn', query: { redirectBack: to.fullPath } });
    }
  } else if (isLoggedIn && !to.matched.some(record => record.meta.isDownloadRoute) &&  to.name !== 'Settings/MobileRedirect') {
    next({ name: 'PersonalWall' });
  } else {
    next();
  }
});

export default router;
